import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// Create axios instance
const user = JSON.parse(localStorage.getItem('user'));
//console.log(user)
const token = user?.token;
//console.log("Sending token:", token);
// ✅ Axios for login/public APIs
export const axiosPublic = axios.create({
  baseURL: 'https://ppxxub.online/apis',
//baseURL: 'http://localhost/Iris',
});

// ✅ Axios for authenticated APIs
export const axiosPrivate = axios.create({
  baseURL: 'https://ppxxub.online/apis',
 //baseURL: 'http://localhost/Iris',
 
});
// Request interceptor
axiosPrivate.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.token;
    const timeZone = 'Asia/Kolkata';

    if (token) {
      config.headers['X-Auth-Token'] = token;
    }
    config.headers['Time-Zone'] = timeZone;

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosPrivate.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');

      // Optional: force reload to reset app state (especially if hooks are not available)
      window.location.href = '/login'; 
    }

    return Promise.reject(error);
  }
);
// API calls
export const login = (email, password) => {
  return axiosPublic.post('/login.php', { email, password });
};

export const getBranches = async () => {
  //console.log(token)
  return await axiosPrivate.get('/get_branches.php');
};

export const deleteBranch = (branch_id) => {
  //console.log(branch_id)
  return axiosPrivate.post('/delete_branch.php',{branch_id} );
};

export const addBranch = (data) => {
  return axiosPrivate.post('/add_branch.php', data);
};

export const editBranch = (data) => {
  return axiosPrivate.post('/edit_branch.php', data);
};

export const getManager = () => {
  return axiosPrivate.get('/get_managers.php');
};
export const addManager=(data)=>{
  //console.log(data)
  return axiosPrivate.post('/add_manager.php',data)
}
export const editManagers=(data)=>{
  return axiosPrivate.post('/edit_manager.php',data)
}

export const getManagerBatches = (id) => {
  return axiosPrivate.get('/get_managerBatches.php', { params: { id } });
};
export const getBatch = (userId) => {
  return axiosPrivate.get('/get_batches.php', { params: { user_id: userId } });
};

export const addBatches = (batch) => {
  //console.log(batch)
  return axiosPrivate.post('/add_batch.php', batch);
};

export const editBatches = (data) => {
  return axiosPrivate.post('/edit_batchBySuperadmin.php', data);
};

export const deleteBatch = (batch_id) => {
  return axiosPrivate.post('/delete_batch.php', {batch_id});
};

export const getDashboard = (user_id) => {
  return axiosPrivate.get('/get_dashboard.php',{ params: { user_id: user_id } });
};

export const changePassword=(id,password)=>{
  return axiosPrivate.post('/edit_password.php',{id,password})
}

export const addStudentDetails=(data)=>{
  //console.log(data)
  return axiosPrivate.post('/add_student.php',data)
}
export const getStudentDetails=(userId)=>{
  return axiosPrivate.get('/get_students.php', { params: { user_id: userId } });
}
export const getStudentDetailsByBatchId=(batchId)=>{
  return axiosPrivate.get('/get_batchStudents.php', { params: { batch_id: batchId } });
}
export const deleteStudent=(student_id)=>{
  return axiosPrivate.post('/delete_student.php',{student_id} );
}
export const editStudentDetails=(data)=>{
  return axiosPrivate.post('/edit_student.php',data);
}
export const getTotalStudents=(userId)=>{
  //console.log(userId)
  return axiosPrivate.get('/get_totalStudents.php', { params: { user_id: userId } });
}
export const getImages=()=>{
  return axiosPrivate.get('/get_images.php');
}
export const getAdminImages=(user_id,batch_id)=>{
  return axiosPrivate.post('/get_adminImages.php',{user_id,batch_id});
}
export default axiosPrivate;
